import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  GoogleMap,
  useJsApiLoader,
} from "@react-google-maps/api";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getGeolocalizacion } from "../../../utils/variablesLocales";
import { ENTORNO } from "../../../utils/constantes";
import {
  nuevo_viaje,
  selecciona_punto_de_partida,
  selecciona_punto_destino,
} from "../../../utils/traductor";

import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import CancelIcon from "@mui/icons-material/Cancel";

const libraries = ["places"];

export function NuevoViaje6() {
  const [Modo, setModo] = useState(1);
  const [PartidaLatitud, setPartidaLatitud] = useState("");
  const [PartidaLongitud, setPartidaLongitud] = useState("");
  const [PartidaDireccion, setPartidaDireccion] = useState("");

  /////////////////////////////////////////////////////
  //drawer
  const [isOpenResumen, setIsOpenResumen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpenResumen((prevState) => !prevState);
  };
  /////////////////////////////////////////////////////

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAMqRtQO0710z-o3NJGNXZtCpfUBObWJe4",
    libraries,
  });
  const mapRef = useRef();
  const autocompleteRefPartida = useRef();
  const autocompleteRefDestino = useRef();

  const containerStyle = {
    width: "100%",
    marginTop: "30px",
    height: "94vh",
    marginLeft: "-1px",
    marginRight: "-1px",
    marginBottom: "0px",
    zIndex: "10",
  };

  const inputStylePartida = {
    boxSizing: "border-box",
    border: "1px solid transparent",
    width: "92%",
    height: "38px",
    padding: "0 12px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
    position: "absolute",
    right: "10px",
    left: "10px",
    top: "20px",
    backgroundColor: "white",
  };

  const inputStyleDestino = {
    boxSizing: "border-box",
    border: "1px solid transparent",
    width: "92%",
    height: "38px",
    padding: "0 12px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
    position: "absolute",
    right: "10px",
    left: "10px",
    top: "58px",
    backgroundColor: "white",
  };

  const onLoadMap = (map) => {
    mapRef.current = map;
  };

  const onLoadAutocompletePartida = (autocomplete) => {
    autocompleteRefPartida.current = autocomplete;
  };

  const handlePlaceChangedPartida = () => {
    const { geometry } = autocompleteRefPartida.current.getPlace();
    const bounds = new window.google.maps.LatLngBounds();
    if (geometry.viewport) {
      bounds.union(geometry.viewport);
    } else {
      bounds.extend(geometry.location);
    }
    mapRef.current.fitBounds(bounds);
  };

  const onLoadAutocompleteDestino = (autocomplete) => {
    autocompleteRefDestino.current = autocomplete;
  };

  const handlePlaceChangedDestino = () => {
    const { geometry } = autocompleteRefDestino.current.getPlace();
    const bounds = new window.google.maps.LatLngBounds();
    if (geometry.viewport) {
      bounds.union(geometry.viewport);
    } else {
      bounds.extend(geometry.location);
    }
    mapRef.current.fitBounds(bounds);
  };

  const navigate = useNavigate();
  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  useEffect(() => {
    if (getGeolocalizacion().split("|")[5] === "true") {
      //gps activado
      if (Modo === 1) {
        setPartidaLatitud(parseFloat(getGeolocalizacion().split("|")[3]));
        setPartidaLongitud(parseFloat(getGeolocalizacion().split("|")[4]));
        setPartidaDireccion(getGeolocalizacion().split("|")[6]);
      } else {
      }
    } else {
      //gps desactivado
    }
  }, []);

  return (
    <div>
      <AppBar style={{ background: "#DC030E" }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            onClick={navigateToInicio}
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 0 }}>
            {nuevo_viaje}
          </Typography>
          <button onClick={toggleDrawer}>Show</button>
        </Toolbar>
      </AppBar>

      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={{
            lat: parseFloat(getGeolocalizacion().split("|")[3]),
            lng: parseFloat(getGeolocalizacion().split("|")[4]),
          }}
          onLoad={onLoadMap}
          zoom={getGeolocalizacion().split("|")[5] === "true" ? 15 : 10}
          options={{
            disableDefaultUI: true,
          }}
        >
          <Autocomplete
            onLoad={onLoadAutocompletePartida}
            onPlaceChanged={handlePlaceChangedPartida}
          >
            <input
              type="text"
              placeholder={selecciona_punto_de_partida}
              style={inputStylePartida}
              value={PartidaDireccion}
              onKeyDown={(e) => {
                e.key === "Enter" && e.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              onChange={(e, data) => {
                setPartidaDireccion(e.target.value);
              }}
            />
          </Autocomplete>
          <Autocomplete
            onLoad={onLoadAutocompleteDestino}
            onPlaceChanged={handlePlaceChangedDestino}
          >
            <input
              type="text"
              placeholder={selecciona_punto_destino}
              style={inputStyleDestino}
            />
          </Autocomplete>
        </GoogleMap>
      )}
      <Drawer
        style={{
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          padding: "10px",
          textAlign: "center",
        }}
        open={isOpenResumen}
        onClose={toggleDrawer}
        direction="bottom"
        className="bla bla bla"
      >
        Hola mundo!!!
      </Drawer>
    </div>
  );
}
